import * as React from 'react';
import type { FAQPage, Question, WithContext } from 'schema-dts';

import type { SanityFaqSection } from '#/lib/sanity/queries/sections';
import { blocksToUnstyledHtmlString } from '#/lib/sanity/utils';

import { schemaOrganization } from './consts';
import { RenderSEOSchema } from './Render';

type FaqSchemaProps = {
  questions: NonNullable<SanityFaqSection['questions']>;
  slug?: string;
  title?: string;
};
export function FaqSchema({ questions, slug, title }: FaqSchemaProps) {
  const questionsSchema: Array<Question> = questions.map((question) => ({
    '@type': 'Question',
    name: question.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: blocksToUnstyledHtmlString(question.answer),
    },
  }));

  const schemaData: WithContext<FAQPage> = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    name: 'Transcend FAQ',
    publisher: schemaOrganization,
    mainEntity: questionsSchema,
  };

  return <RenderSEOSchema schemaData={schemaData} />;
}
